import { useMutation, useQueryClient } from "@tanstack/react-query";

import { publishTheme } from "../../api/Theme";
import { ITheme } from "../../typings/Theme";
import { useFormContext } from "react-hook-form";

export const useThemePublish = () => {
  const form = useFormContext<ITheme>();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ theme }: { theme: Partial<ITheme> }) => publishTheme(theme),
    onSuccess(updatedTheme) {
      form?.reset(updatedTheme);
      queryClient.invalidateQueries(["themes"]);
      queryClient.invalidateQueries(["theme", updatedTheme.id]);
    },
  });
};
